import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Button } from '@components/button';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { api } from 'api';

import { Modal, ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = ModalProps<{
  departmentId: number;
}>;

export const DeleteDepartmentModal = (props: Props) => {
  const { current, t, userStore } = useStore();
  const { departmentId, closeModal } = props;
  const { showSuccess } = useToaster();

  const queryClient = useQueryClient();
  const submit = useMutation(() => api.departments.remove(departmentId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['departments']);
      current.loadInfo(); // To fetch the departments again for create/edit job
      userStore.load(true); // To load the user's updated departments
      showSuccess(t('modals.deletedepartment.success'));
      closeModal();
    },
  });

  return (
    <Modal>
      <Modal.Header text={t('modals.deletedepartment.header')} />
      <Text text={t('modals.deletedepartment.content')} />
      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={closeModal}
          text={t('modals.deletedepartment.cancel')}
        />
        <Button
          isDisabled={submit.isLoading}
          onClick={() => submit.mutate()}
          text={t('modals.deletedepartment.save')}
        />
      </Modal.Actions>
    </Modal>
  );
};
